const getLocale = () => {
  if (process.env.VUE_APP_DEFAULT_LANGUAGE === 'fi') {
    return 'fi-FI';
  }

  return 'en-GB'; // default
};

const getTimeOptions = () => ({
  dateStyle: 'medium',
  timeStyle: 'long',
});

const translateDate = (time) => new Date(time).toLocaleString(getLocale(), getTimeOptions());

export default {
  translateDate,
};
